import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./accordionRow.html";
class AccordionRow extends LightningElement {
  constructor(...args) {
    super(...args);
    this.hideArrowIcon = false;
    this._isOpen = false;
  }
  get isOpen() {
    return this._isOpen;
  }
  set isOpen(value) {
    this._isOpen = value;
  }
  toggle() {
    var _querySelector;
    this._isOpen = !this._isOpen;
    const classList = (_querySelector = this.template.querySelector('.container')) === null || _querySelector === void 0 ? void 0 : _querySelector.classList;
    if (classList) {
      classList.toggle('appx-accordion-row-opened', this._isOpen);
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(AccordionRow, {
  publicProps: {
    hideArrowIcon: {
      config: 0
    },
    isOpen: {
      config: 3
    }
  },
  fields: ["_isOpen"]
});
const __lwc_component_class_internal = _registerComponent(AccordionRow, {
  tmpl: _tmpl,
  sel: "appx-accordion-row",
  apiVersion: 62
});
export default __lwc_component_class_internal;